import axios from "../axiosClientCert";

export const getCertificates = async (
  PageNumber: any,
  pageSize: any,
  TcCode: any,
  SiteCode: any,
  BlockCode: any,
  deviceCode: any,
  status: any,
  fromDate: any,
  toDate: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmscertificate/Certificate/GetAll`, {
    params: {
      PageNumber,
      pageSize,
      TcCode,
      SiteCode,
      BlockCode,
      deviceId: deviceCode,
      status,
      fromDate,
      toDate,
      SortBy,
      SortDirection,
      searchText,
    },
    signal,
  });

  return res?.data;
};

export const getCommonCertificates = async (
  PageNumber: any,
  pageSize: any,
  // TcCode: any,
  // SiteCode: any,
  // BlockCode: any,
  // deviceCode: any,
  // DeviceId: any,
  // status: any,
  // fromDate: any,
  // toDate: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/dmscertificate/CommonCertificate/getall`, {
    params: {
      PageNumber,
      pageSize,
      // TcCode,
      // SiteCode,
      // BlockCode,
      // deviceCode,
      // DeviceId,
      // status,
      // fromDate,
      // toDate,
      SortBy,
      SortDirection,
      searchText,
    },
    signal,
  });

  return res?.data;
};
